<template>
  <div class="order-confirm">
    <div class="step-badge">
      <i class="el-icon-s-order"></i>
      <span>{{ $t('buy.steps.badge.step5') }}</span>
    </div>
    <div class="section-header">
      <h3>{{ $t('buy.order.title') }}</h3>
      <p class="section-desc">{{ $t('buy.order.subtitle') }}</p>
    </div>

    <div class="order-layout">
      <!-- 左侧：订单详情 -->
      <div class="order-details">
        <!-- 方案信息 -->
        <div class="detail-card">
          <div class="detail-card-header">
            <i class="el-icon-s-grid"></i>
            <span>{{ $t('buy.order.planDetails') }}</span>
          </div>
          <div class="detail-card-body">
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.order.selectedPlan') }}</span>
              <span class="detail-value plan-name">{{ planDisplayName }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.order.billingCycle') }}</span>
              <span class="detail-value">{{ billingCycleLabel }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.order.planPrice') }}</span>
              <span class="detail-value">{{ formatMoney(orderData.planPrice) }} / {{ billingCycleLabel }}</span>
            </div>
          </div>
        </div>

        <!-- 语言选择 -->
        <div class="detail-card">
          <div class="detail-card-header">
            <i class="el-icon-chat-line-square"></i>
            <span>{{ $t('buy.order.languagesDetails') }}</span>
          </div>
          <div class="detail-card-body">
            <div class="language-tags">
              <el-tag
                v-for="language in selectedLanguagesList"
                :key="language.id"
                size="small"
                effect="plain"
              >
                {{ language.name }}
              </el-tag>
            </div>
          </div>
        </div>

        <!-- 审计标准 -->
        <div class="detail-card">
          <div class="detail-card-header">
            <i class="el-icon-document"></i>
            <span>{{ $t('buy.order.standardsDetails') }}</span>
          </div>
          <div class="detail-card-body">
            <div class="standards-list">
              <div 
                v-for="std in selectedStandardsList" 
                :key="std.id"
                class="standard-item"
              >
                <div class="standard-item-left">
                  <i class="el-icon-circle-check" style="color: #10b981;"></i>
                  <span>{{ std.name }}</span>
                </div>
                <span class="standard-item-price">{{ formatMoney(std.price) }}/{{ $t('buy.licences.perYear') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 席位信息 -->
        <div class="detail-card">
          <div class="detail-card-header">
            <i class="el-icon-user"></i>
            <span>{{ $t('buy.order.seatsDetails') }}</span>
          </div>
          <div class="detail-card-body">
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.licences.auditor.title') }}</span>
              <span class="detail-value">{{ $tc('buy.order.licenceCount', orderData.auditorSeats, { count: orderData.auditorSeats }) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.licences.admin.title') }}</span>
              <span class="detail-value">{{ $tc('buy.order.licenceCount', orderData.includedAdminSeats + orderData.extraAdminSeats, { count: orderData.includedAdminSeats + orderData.extraAdminSeats }) }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.licences.supplier.title') }}</span>
              <span class="detail-value supplier-unlimited">{{ $t('buy.licences.supplier.unlimited') }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ $t('buy.licences.client.title') }}</span>
              <span class="detail-value supplier-unlimited">{{ $t('buy.licences.client.unlimited') }}</span>
            </div>
          </div>
        </div>

               <!-- 审计标准 -->
        <div class="detail-card">
          <div class="detail-card-header">
            <i class="el-icon-document"></i>
            <span>{{ $t('buy.order.storage.title') }}</span>
          </div>
          <div class="detail-card-body">
            <div class="standards-list">
              <div 
                class="standard-item"
              >
                <div class="standard-item-left">
                  <i class="el-icon-circle-check" style="color: #10b981;"></i>
                  <span>{{ $t('buy.order.storage.desc') }}</span>
                  <!-- <el-tag size="mini" type="success">{{ $t('buy.order.storage.included') }}</el-tag> -->
                </div>
                <span class="standard-item-price free">{{ $t('buy.order.storage.payAsYouGo') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="detail-card">
          <div class="detail-card-header">
            <i class="el-icon-office-building"></i>
            <span>Account Info</span>
          </div>
          <div class="detail-card-body">
            <div class="auto-company-note">
              登录账户信息将自动用于创建订单，当前步骤不再手动填写 Company。
            </div>
            <div class="detail-row">
              <span class="detail-label">Contact</span>
              <span class="detail-value">{{ accountCompany.contactName || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Email</span>
              <span class="detail-value">{{ accountCompany.email || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Company</span>
              <span class="detail-value">{{ accountCompany.companyName || '-' }}</span>
            </div>
          </div>
        </div> -->

        <!-- 优惠码 -->
        <div class="promo-section">
          <el-input 
            v-model="promoCode" 
            :placeholder="$t('buy.order.promoPlaceholder')"
            class="promo-input"
            size="medium"
          >
            <el-button slot="append" @click="applyPromo" :loading="applyingPromo">
              {{ $t('buy.order.applyPromo') }}
            </el-button>
          </el-input>
          <div v-if="promoApplied" class="promo-success">
            <i class="el-icon-circle-check"></i>
            {{ $t('buy.order.promoApplied', { discount: promoDiscount }) }}
          </div>
        </div>
      </div>

      <!-- 右侧：价格汇总 -->
      <div class="order-summary-panel">
        <div class="summary-card">
          <!-- Premium Header -->
          <div class="summary-header">
            <h4 class="summary-title">{{ $t('buy.order.orderSummary') }}</h4>
            <div class="header-icon">
              <i class="el-icon-wallet"></i>
            </div>
          </div>
          
          <div class="summary-items">
            <div class="summary-item">
              <div class="item-label">
                <i class="el-icon-s-grid item-icon"></i>
                <span>{{ $t('buy.order.package') }}</span>
              </div>
              <span class="item-value">{{ formatMoney(displayPlanPrice) }}</span>
            </div>
            <div class="summary-item">
              <div class="item-label">
                <i class="el-icon-document item-icon"></i>
                <span>{{ $t('buy.order.standardsPrice') }}</span>
              </div>
              <span class="item-value">{{ formatMoney(displayStandardsPrice) }}</span>
            </div>
            <div class="summary-item">
              <div class="item-label">
                <i class="el-icon-user item-icon"></i>
                <span>{{ $t('buy.order.seatsPrice') }}</span>
              </div>
              <span class="item-value">{{ formatMoney(displaySeatsPrice) }}</span>
            </div>
            <div class="summary-item">
              <div class="item-label">
                <i class="el-icon-document item-icon"></i>
                <span>{{ $t('buy.order.storage.title') }}</span>
              </div>
              <span class="item-value">{{ $t('buy.order.storage.payAsYouGo') }}</span>
            </div>
            <div class="summary-item discount" v-if="promoApplied">
              <div class="item-label">
                <i class="el-icon-present item-icon"></i>
                <span>{{ $t('buy.order.promoDiscount') }}</span>
              </div>
              <span class="item-value">-{{ formatMoney(discountAmount) }}</span>
            </div>
          </div>

          <div class="summary-divider">
            <div class="divider-line"></div>
          </div>

          <div class="summary-total-wrapper">
            <div class="total-meta-row">
              <span class="total-label">{{ $t('buy.order.totalMonthly') }}</span>
              <span class="total-period">{{ billingCycleLabel }}</span>
            </div>
            <div class="total-price-box">
              <div class="price-content">
                <span class="total-currency">{{ displayCurrency }}</span>
                <span class="total-amount">{{ formatPrice(finalTotal) }}</span>
              </div>
              <div class="price-accent" aria-hidden="true"></div>
            </div>
          </div>

          <div class="vat-note">
            <i class="el-icon-info"></i>
            <span>{{ $t('buy.order.vatNote') }}</span>
          </div>

          <!-- 协议 -->
          <div class="agreement-section">
            <el-checkbox v-model="agreedTerms">
              {{ $t('buy.order.agreePrefix') }}
              <el-link type="primary" :underline="false" @click.prevent.stop="showTermsDialog = true">
                {{ $t('buy.order.termsOfService') }}
              </el-link>
              {{ $t('buy.order.agreeAnd') }}
              <el-link type="primary" :underline="false" @click.prevent.stop="showPrivacyDialog = true">
                {{ $t('buy.order.privacyPolicy') }}
              </el-link>
            </el-checkbox>
          </div>

          <!-- 安全徽标 -->
          <div class="security-badges">
            <div class="badge-item">
              <i class="el-icon-lock"></i>
              <span>{{ $t('buy.order.sslEncrypted') }}</span>
            </div>
          </div>

          <!-- 标准可稍后购买提示 -->
          <div class="info-banner">
            <i class="el-icon-info"></i>
            <span>{{ $t('buy.standards.infoBanner') }}</span>
          </div>

          <!-- 保障信息 -->

        </div>
      </div>
    </div>

    <!-- 条款弹窗 -->
    <el-dialog :title="$t('buy.order.termsOfService')" :visible.sync="showTermsDialog" width="80%" top="5vh">
      <div class="terms-content" ref="termsContent">
        <h4 class="terms-block-title">{{ $t('buy.order.termsOfService') }}</h4>
        <template v-if="Array.isArray(termsSections)">
          <div v-for="(section, i) in termsSections" :key="i" class="terms-section">
            <h5 v-if="section.title" class="terms-title">{{ section.title }}</h5>
            <p v-for="(paragraph, pIndex) in section.paragraphs" :key="`terms-p-${pIndex}`" class="terms-p">
              {{ paragraph }}
            </p>
            <ul v-if="section.list && section.list.length" class="terms-list">
              <li v-for="(item, j) in section.list" :key="j" class="terms-list-item">{{ item }}</li>
            </ul>
          </div>
        </template>
        <p v-else class="terms-p">{{ $t('legal.termsContent') }}</p>
      </div>
      <span slot="footer">
        <el-button @click="showTermsDialog = false">{{ $t('buy.order.close') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('buy.order.privacyPolicy')" :visible.sync="showPrivacyDialog" width="80%" top="5vh">
      <div class="terms-content">
        <h4 class="terms-block-title">{{ $t('buy.order.privacyPolicy') }}</h4>
        <template v-if="Array.isArray(privacySections)">
          <div v-for="(section, i) in privacySections" :key="i" class="terms-section">
            <h5 v-if="section.title" class="terms-title">{{ section.title }}</h5>
            <p v-for="(paragraph, pIndex) in section.paragraphs" :key="`privacy-p-${pIndex}`" class="terms-p">
              {{ paragraph }}
            </p>
            <ul v-if="section.list && section.list.length" class="terms-list">
              <li v-for="(item, j) in section.list" :key="j" class="terms-list-item">{{ item }}</li>
            </ul>
          </div>
        </template>
        <p v-else class="terms-p">{{ $t('legal.privacyContent') }}</p>
      </div>
      <span slot="footer">
        <el-button @click="showPrivacyDialog = false">{{ $t('buy.order.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { displayCurrencyLabel, formatPrice as formatPriceValue } from '@/utils/currency'
export default {
  name: 'OrderConfirm',
  props: {
    orderData: {
      type: Object,
      default: () => ({
        planId: 'professional',
        billingCycle: 'one_year',
        planPrice: 2640,
        languages: ['english'],
        standards: ['iso9001'],
        standardsPrice: 120011,
        auditorSeats: 1,
        includedAdminSeats: 0,
        extraAdminSeats: 0,
        seatsPrice: 60
      })
    },
    purchaseConfig: {
      type: Object,
      default: null
    },
    confirmState: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      agreedTerms: false,
      promoCode: '',
      promoApplied: false,
      promoDiscount: 0,
      applyingPromo: false,
      showTermsDialog: false,
      showPrivacyDialog: false,
      allStandards: [
        { id: 'iso9001', name: 'ISO 9001:2015', price: 1200, included: false },
        { id: 'iatf16949', name: 'IATF 16949:2016', price: 1620, included: false },
        { id: 'vda63', name: 'VDA 6.3', price: 1620, included: false },
        { id: 'vda65', name: 'VDA 6.5', price: 1200, included: false },
        { id: 'iso14001', name: 'ISO 14001:2015', price: 1200, included: false },
        { id: 'iso45001', name: 'ISO 45001:2018', price: 1200, included: false },
        { id: 'iso27001', name: 'ISO 27001:2022', price: 1620, included: false },
        { id: 'customTemplate', name: 'Custom Template Creator', price: 2400, included: false }
      ]
    }
  },
  computed: {
    accountCompany() {
      return this.orderData.company || {}
    },
    planDisplayName() {
      const key = `buy.plan.plans.${this.orderData.planId}.name`
      if (this.$te(key)) return this.$t(key)
      const plan = this.purchaseConfig && this.purchaseConfig.plans && this.purchaseConfig.plans[this.orderData.planId]
      return (plan && plan.name) || this.orderData.planId
    },
    selectedStandardsList() {
      const configStandards = this.purchaseConfig && Array.isArray(this.purchaseConfig.standards)
        ? this.purchaseConfig.standards
        : []
      const fallbackMap = this.allStandards.reduce((map, item) => {
        map[item.id] = item
        return map
      }, {})
      return this.orderData.standards.map(id => {
        const configItem = configStandards.find(item => item.id === id)
        if (configItem) {
          return {
            id,
            name: this.standardLabel(id, configItem.name),
            price: this.fromMinor(configItem.price)
          }
        }
        const fallback = fallbackMap[id]
        return fallback ? { ...fallback, name: this.standardLabel(id, fallback.name) } : null
      }).filter(Boolean)
    },
    selectedLanguagesList() {
      const languageIds = Array.isArray(this.orderData.languages) && this.orderData.languages.length
        ? this.orderData.languages
        : ['english']
      return languageIds.map(id => ({
        id,
        name: this.languageLabel(id)
      }))
    },
    termsSections() {
      return this.normalizeLegalSections(this.$t('legal.termsContent'))
    },
    privacySections() {
      return this.normalizeLegalSections(this.$t('legal.privacyContent'))
    },
    displayPlanPrice() {
      return this.orderData.planPrice
    },
    displayStandardsPrice() {
      return this.orderData.billingCycle === 'two_year'
        ? this.orderData.standardsPrice * 2  // 2年
        : this.orderData.standardsPrice       // 1年
    },
    displaySeatsPrice() {
      return this.orderData.billingCycle === 'two_year'
        ? this.orderData.seatsPrice * 2  // 2年
        : this.orderData.seatsPrice       // 1年
    },
    billingCycleLabel() {
      return this.orderData.billingCycle === 'two_year'
        ? this.$t('buy.summary.year2')
        : this.$t('buy.summary.year1')
    },
    subtotal() {
      return this.displayPlanPrice + this.displayStandardsPrice + this.displaySeatsPrice
    },
    discountAmount() {
      return Math.round(this.subtotal * this.promoDiscount / 100)
    },
    finalTotal() {
      return this.subtotal - this.discountAmount
    },
    displayCurrency() {
      const raw = (this.purchaseConfig && this.purchaseConfig.displayCurrency) || this.orderData.currency || 'RMB'
      return displayCurrencyLabel(raw)
    }
  },
  watch: {
    agreedTerms() {
      this.emitState()
    },
    promoCode() {
      this.emitState()
    },
    confirmState: {
      handler() {
        this.applyConfirmState()
      },
      deep: true
    }
  },
  methods: {
    applyConfirmState() {
      if (!this.confirmState) return
      this.agreedTerms = !!this.confirmState.termsAccepted
      this.promoCode = this.confirmState.promoCode || ''
    },
    normalizeLegalSections(items) {
      if (!Array.isArray(items)) return []
      return items.map(item => {
        if (!item) return { title: '', paragraphs: [], list: [] }
        if (typeof item === 'object') {
          return {
            title: item.title || '',
            paragraphs: Array.isArray(item.paragraphs)
              ? item.paragraphs
              : (item.text ? [item.text] : []),
            list: Array.isArray(item.list) ? item.list : []
          }
        }
        const parts = String(item).split(/\n{2,}/).map(part => part.trim()).filter(Boolean)
        const [title = '', ...paragraphs] = parts
        return { title, paragraphs, list: [] }
      })
    },
    fromMinor(amount) {
      return Math.round(Number(amount || 0)) / 100
    },
    languageLabel(languageId) {
      const label = this.$t(`buy.languages.items.${languageId}`)
      return label === `buy.languages.items.${languageId}` ? languageId : label
    },
    standardLabel(id, fallbackName) {
      const key = `buy.standards.items.${id}.fullname`
      return this.$te(key) ? this.$t(key) : fallbackName || id
    },
    emitState() {
      this.$nextTick(() => {
        this.$emit('validate', this.agreedTerms)
        this.$emit('order-confirm-updated', {
          termsAccepted: this.agreedTerms,
          promoCode: this.promoCode,
          company: { ...this.accountCompany }
        })
      })
    },
    formatPrice(price) {
      if (typeof price !== 'number') return formatPriceValue(0)
      return formatPriceValue(price)
    },
    formatMoney(price) {
      return `${this.displayCurrency} ${this.formatPrice(price)}`
    },
    applyPromo() {
      if (!this.promoCode.trim()) return
      this.applyingPromo = true
      // 模拟验证优惠码
      setTimeout(() => {
        if (this.promoCode.toUpperCase() === 'LPT2026') {
          this.promoApplied = true
          this.promoDiscount = 10
          this.emitState()
          this.$message.success(this.$t('buy.order.promoSuccess'))
        } else {
          this.$message.error(this.$t('buy.order.promoInvalid'))
        }
        this.applyingPromo = false
      }, 1000)
    }
  },
  created() {
    this.applyConfirmState()
    this.$emit('validate', this.agreedTerms)
  },
  mounted() {
    this.emitState()
  }
}
</script>

<style lang="scss" scoped>
.order-confirm {
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
}

.step-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 20px;
  background: linear-gradient(135deg, #6366f1, #818cf8);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 24px;
  i {
    font-size: 14px;
  }
}

.section-header {
  text-align: center;
  margin-bottom: 36px;

  h3 {
    font-size: 24px;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 8px;
  }

  .section-desc {
    color: #64748b;
    font-size: 15px;
    margin: 0;
  }
}

.order-layout {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 30px;
  align-items: start;
}

.order-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-card {
  border: 1.5px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;

  .detail-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    font-weight: 600;
    font-size: 15px;
    color: #334155;

    i {
      font-size: 18px;
      color: #6366f1;
    }
  }

  .detail-card-body {
    padding: 16px 20px;
  }
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }

  .detail-label {
    font-size: 14px;
    color: #64748b;
  }

  .detail-value {
    font-size: 14px;
    color: #1e293b;
    font-weight: 600;

    &.plan-name {
      color: #6366f1;
      font-size: 16px;
    }

    &.supplier-unlimited {
      color: #10b981;
    }
  }
}

.auto-company-note {
  margin-bottom: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 13px;
  line-height: 1.5;
}

.language-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  ::v-deep .el-tag {
    border-radius: 999px;
    border-color: #c7d2fe;
    color: #4f46e5;
    background: #eef2ff;
  }
}

.standards-list {
  .standard-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f1f5f9;

    &:last-child {
      border-bottom: none;
    }

    .standard-item-left {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #334155;
    }

    .standard-item-price {
      font-size: 14px;
      font-weight: 600;
      color: #1e293b;

      &.free {
        color: #10b981;
      }
    }
  }
}

.promo-section {
  margin-top: 4px;

  .promo-input {
    ::v-deep .el-input__inner {
      border-radius: 10px 0 0 10px;
    }
    ::v-deep .el-input-group__append {
      border-radius: 0 10px 10px 0;
    }
  }

  .promo-success {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    color: #10b981;
    font-size: 13px;
    font-weight: 500;
  }
}

.summary-card {
  position: sticky;
  background: #fff;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 20px 48px rgba(99, 102, 241, 0.08), 0 1px 3px rgba(0,0,0,0.05);
  border: 1px solid #f1f5f9;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%)
  }
}

.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;

  .summary-title {
    font-size: 20px;
    font-weight: 800;
    color: #1e293b;
    margin: 0;
  }

  .header-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #e0e7ff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4f46e5;
    font-size: 20px;
  }
}

.summary-items {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .summary-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .item-label {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 15px;
      color: #64748b;
      font-weight: 500;

      .item-icon {
        color: #94a3b8;
        font-size: 16px;
      }
    }

    .item-value {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
    }

    &.discount {
      .item-label, .item-icon {
        color: #10b981 !important;
      }
      .item-value {
        color: #10b981;
        font-weight: 700;
      }
      padding: 10px;
      margin: 4px -10px -10px -10px;
      background: #f0fdf4;
      border-radius: 8px;
    }
  }
}

.summary-divider {
  margin: 24px 0;
  
  .divider-line {
    height: 2px;
    background: repeating-linear-gradient(to right, #e2e8f0, #e2e8f0 6px, transparent 6px, transparent 12px);
  }
}

.summary-total-wrapper {
  margin-bottom: 24px;

  .total-meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .total-label {
    font-size: 14px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0;
  }

  .total-period {
    flex: 0 0 auto;
    padding: 5px 10px;
    border-radius: 999px;
    background: rgba(3, 210, 197, 0.1);
    border: 1px solid rgba(3, 210, 197, 0.22);
    color: #047c88;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
  }

  .total-price-box {
    position: relative;
    overflow: hidden;
    background:
      linear-gradient(135deg, rgba(6, 73, 184, 0.06), rgba(3, 210, 197, 0.11)),
      #f8fafc;
    border: 1px solid rgba(6, 73, 184, 0.12);
    border-radius: 12px;
    padding: 22px 20px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85), 0 10px 28px rgba(15, 23, 42, 0.06);

    .price-content {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: baseline;
      gap: 6px;
      min-width: 0;
      width: 100%;
    }

    .total-currency {
      margin-right: 30px;
      font-size: 13px;
      font-weight: 800;
      color: #0649b8;
      margin-right: 10px;
    }

    .total-amount {
      font-size: 19px;
      font-weight: 700;
      width: 100%;
      color: #0f172a;
      line-height: 1;
      letter-spacing: 0;
      word-break: break-word;
    }

    .price-accent {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 5px;
      background: linear-gradient(180deg, #0649b8 0%, #03d2c5 100%);
    }
  }
}

.vat-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  margin-bottom: 28px;
  background: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #f1f5f9;

  i {
    color: #94a3b8;
    font-size: 16px;
  }
}

.agreement-section {
  margin-bottom: 20px;
  
  ::v-deep .el-checkbox__label {
    font-size: 13px;
    color: #475569;
    white-space: normal;
    line-height: 1.6;
  }
}

.security-badges {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 14px 0;
  margin-bottom: 14px;
  border-top: 1px solid #f1f5f9;

  .badge-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #94a3b8;

    i {
      font-size: 14px;
      color: #10b981;
    }
  }
}

.info-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
  margin-top: 4px;
  font-size: 13px;
  color: #92400e;

  i {
    font-size: 18px;
    color: #f59e0b;
    flex-shrink: 0;
  }
}

.guarantee {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #64748b;
  padding: 12px;
  background: #f0fdf4;
  border-radius: 10px;

  i {
    color: #10b981;
    font-size: 16px;
  }
}

.terms-content {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
    &:hover { background: #94a3b8; }
  }
}

.terms-section {
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
}

.terms-block-title {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 20px;
}

.terms-title {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 14px;
  line-height: 1.4;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;
}

.terms-p {
  margin: 0 0 14px;
  line-height: 1.2;
  font-size: 14.5px;
  color: #475569;
  text-align: justify;
  word-break: break-word;
}

.terms-list {
  list-style: none;
  padding: 0;
  margin: 10px 0;

  .terms-list-item {
    position: relative;
    padding-left: 20px;
    margin-bottom: 10px;
    line-height: 1.7;
    font-size: 14.5px;
    color: #475569;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.5em;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #6366f1;
      transform: translateY(-50%);
    }
  }
}

@media (max-width: 991px) {
  .order-layout {
    grid-template-columns: 1fr;
  }

  .summary-card {
    position: static;
    padding: 24px;
  }
}

@media (max-width: 640px) {
  .order-confirm {
    max-width: 100%;
  }

  .step-badge {
    padding: 5px 12px;
    margin-bottom: 16px;
    font-size: 12px;
  }

  .section-header {
    text-align: left;
    margin-bottom: 24px;

    h3 {
      font-size: 21px;
    }

    .section-desc {
      font-size: 13px;
      line-height: 1.5;
    }
  }

  .order-layout {
    gap: 18px;
  }

  .order-details {
    gap: 12px;
  }

  .detail-card {
    border-radius: 12px;
  }

  .detail-card .detail-card-header,
  .detail-card .detail-card-body {
    padding-left: 14px;
    padding-right: 14px;
  }

  .detail-card .detail-card-header {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .detail-card .detail-card-body {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .detail-row,
  .standards-list .standard-item,
  .summary-items .summary-item {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  .standards-list .standard-item-left {
    align-items: flex-start;
  }

  .detail-row .detail-value,
  .standards-list .standard-item .standard-item-price {
    word-break: break-word;
  }

  .promo-section .promo-input {
    ::v-deep .el-input__inner {
      min-height: 42px;
    }

    ::v-deep .el-input-group__append {
      padding: 0 12px;
    }
  }

  .summary-card {
    border-radius: 14px;
    padding: 20px 16px;
    box-shadow: none;
  }

  .summary-header {
    margin-bottom: 22px;

    .summary-title {
      font-size: 18px;
    }
  }

  .summary-total-wrapper .total-price-box {
    padding: 16px 14px;

    .price-content {
      flex-wrap: wrap;
    }

    .total-amount {
      font-size: 26px;
    }
  }

  .vat-note {
    align-items: flex-start;
    justify-content: flex-start;
  }

  .security-badges {
    justify-content: flex-start;
  }

  .terms-title {
    font-size: 16px;
  }

  .terms-p,
  .terms-list .terms-list-item {
    font-size: 13px;
    text-align: left;
  }
}
</style>
